export default __webpack_public_path__ + "static/media/serviços2.01deff4a.svg";